localStorage.removeItem('loadingUrl');

localStorage.setItem("loadingUrl",window.location.href);
let tenantConfig;

function setOktaConfig(configKey) {
	tenantConfig = window.oktaBrandingUrls[configKey];
	window.tenantConfig = tenantConfig;
}

const whiteListURLs = ['?source=', 'app.infucarerx.health', 'connect.performspecialty.com', 'www.soleoconnect.com', 'matrixcare.citushealth.com', 'my.kabafusion.com', 'www.virtisconnect.com', 'connect.vitalcare.com','intermountain.citushealth.com','connect.kennebecpharmacy.com','app.realospecialtycare.com','myanovo.anovorx.com','care.nutrishare.com','app.orsini.com', 'app.fillpointhealth.com', 'patients.premierhcs.com','app.citushealth.jp', 'infusiontext-uat.optum.com', 'infusiontext.optum.com', 'engage-eforms', 'app-uat.kabaapp.com','specialtyapp.mckesson.com','app.medrxinfusion.com', 'rxtogoconnect.flcancer.com','connect.ascellahealth.com','patientconnect.avevorx.com','redchipspecialty.citushealth.com', 'connect.cascadehc.org'];
if(whiteListURLs.some(ele=>window.location.href.includes(ele))){
	let sourceTenantIds = {
	  citushealth: 1,
	  alliance: 3,
	  horizon: 10,
	  pharmacare: 16,
	  corstrata: 17,
	  intramed: 19,
	  mha: 24,
	  wellsky: 89,
	  palmetto: 99,
	  henryford: 100,
	  performspecialty: 149,
	  infucarerx: 184,
	  matrixcare: 413,
	  soleoconnect: 531,
	  kabafusion: 372,
	  virtisconnect: 532,
	  vitalcare: 711,
	  intermountain: 784,
	  ascellahealth: 1254,
	  kennebec:865,
	  realoscp:802,
	  anovorx:1010,
	  orsini:953,
	  fillpoint:1132,
	  premier:1111,
	  nutrishare:1014,
	  Citushealth4:558,
	  mckesson:1202,
	  rxtogo:1186,
	  medrx:1178,
	  avevorx:1278,
	  redchip:1308,
	  cascadehc:1335,
	  engage_matrixcare:1268,
	  optum_uat:14
	};
	let sourceTenant;
	// Cache URL to avoid repeated DOM access
	const currentUrl = window.location.href;
	// Set default Okta configuration for production environment
	setOktaConfig('citushealth');
	if (currentUrl.indexOf("app.infucarerx.health")!=-1) {
		sourceTenant = 'infucarerx';
	} else if (currentUrl.indexOf("connect.performspecialty.com")!=-1) {
		sourceTenant = 'performspecialty';
	} else if (currentUrl.indexOf("www.soleoconnect.com")!=-1) {
		sourceTenant = 'soleoconnect';
		setOktaConfig('soleoconnect');
	} else if (currentUrl.indexOf("matrixcare.citushealth.com")!=-1) {
		sourceTenant = 'matrixcare';
		setOktaConfig('matrixcare');
	} else if (currentUrl.indexOf("my.kabafusion.com")!=-1) {
		sourceTenant = 'kabafusion';
		setOktaConfig('kabafusion');
		assetsUrl = "https://assets.kabafusion.com";
	} else if (currentUrl.indexOf("www.virtisconnect.com")!=-1) {
		sourceTenant = 'virtisconnect';
	} else if (currentUrl.indexOf("connect.vitalcare.com")!=-1) {
		sourceTenant = 'vitalcare';
		setOktaConfig('vitalcare');
	} else if (currentUrl.indexOf("intermountain.citushealth.com")!=-1) {
		sourceTenant = 'intermountain';
	} else if (currentUrl.indexOf("connect.ascellahealth.com")!=-1) {
		sourceTenant = 'ascellahealth';
		setOktaConfig('ascellahealth');
	} else if (currentUrl.indexOf("connect.kennebecpharmacy.com")!=-1) {
		sourceTenant = 'kennebec';
		setOktaConfig('kennebec');
	} else if (currentUrl.indexOf("app.realospecialtycare.com")!=-1) {
		sourceTenant = 'realoscp';
		setOktaConfig('realo');
	} else if (currentUrl.indexOf("myanovo.anovorx.com")!=-1) {
		sourceTenant = 'anovorx';
		setOktaConfig('myanovo');
	} else if (currentUrl.indexOf("care.nutrishare.com")!=-1) {
		sourceTenant = 'nutrishare';
		setOktaConfig('nutrishare');
	} else if (currentUrl.indexOf("app-uat.kabaapp.com")!=-1) {
		sourceTenant = 'kabafusion';
		assetsUrl = "https://assets-uat.kabaapp.com";
	} else if (currentUrl.indexOf("app.orsini.com")!=-1) {
		sourceTenant = 'orsini';
		setOktaConfig('orsini');
	} else if (currentUrl.indexOf("app.fillpointhealth.com")!=-1) {
		sourceTenant = 'fillpoint';
		setOktaConfig('fillpoint');
	} else if (currentUrl.indexOf("patients.premierhcs.com")!=-1) {
		sourceTenant = 'premier';
		setOktaConfig('premier');
	} else if (currentUrl.indexOf("specialtyapp.mckesson.com")!=-1) {
		sourceTenant = 'mckesson';
		setOktaConfig('specialityapp');
	} else if (currentUrl.indexOf("app.medrxinfusion.com")!=-1) {
		sourceTenant = 'medrx';
		setOktaConfig('medrx');
	} else if (currentUrl.indexOf("patientconnect.avevorx.com")!=-1) {
		sourceTenant = 'avevorx';
	} else if (currentUrl.indexOf("redchipspecialty.citushealth.com")!=-1) {
		sourceTenant = 'redchip';
	} else if (currentUrl.indexOf("connect.cascadehc.org")!=-1) {
		sourceTenant = 'cascadehc';
	} else if (currentUrl.indexOf("rxtogoconnect.flcancer.com")!=-1) {
		sourceTenant = 'rxtogo';
		setOktaConfig('rxtogo');
	} else if (currentUrl.indexOf("app.citushealth.jp")!=-1) {
		sourceTenant = 'Citushealth4';
	} else if (currentUrl.indexOf("engage-eforms-qa.matrixcare.com")!=-1) {
		sourceTenant = 'engage_matrixcare';
		setOktaConfig('qa');
	} else if (currentUrl.indexOf("engage-eforms-stage.matrixcare.com")!=-1) {
		sourceTenant = 'engage_matrixcare';
		setOktaConfig('stage');
	} else if (currentUrl.indexOf("engage-eforms.matrixcare.com")!=-1) {
		sourceTenant = 'engage_matrixcare';
		setOktaConfig('matrixcare');
	} else if (currentUrl.indexOf("infusiontext-uat.optum.com")!=-1) {
		assetsUrl = "https://assets-infusiontext-uat.optum.com";
		sourceTenant = 'optum_uat';
		setOktaConfig('qa');
	} else if (currentUrl.indexOf("infusiontext.optum.com")!=-1) {
		assetsUrl = "https://assets-infusiontext.optum.com";
		sourceTenant = 'optum_uat';
		setOktaConfig('citushealth');
	} else {
		let sourceDomain = currentUrl.split("?source=")[1]||"citushealth.callbellapp.com";
		sourceTenant = sourceDomain.split('.')[0];
		// Set default Okta configuration for production environment
		setOktaConfig('citushealth');
	}
	let sourceTenantId = sourceTenantIds[sourceTenant]||1;

	// Function to apply branding data
	function applyBranding(data) {
		if (data.css && data.css.length) {
			var cssElm = document.createElement("link");
			cssElm.setAttribute("rel", "stylesheet")
			cssElm.setAttribute("type", "text/css")
			cssElm.setAttribute("href", data.css[0])
			document.head.appendChild(cssElm);
		}
		if (data.siteTitle) {
			$('title').html(data.siteTitle);
		}
		if (data.favicon) {
			$('link[rel="icon"]').attr('href',data.favicon);
		}
	}

	// Apply cached branding immediately if available and tenant ID matches
	const cachedTenantId = localStorage.getItem('sourceTenantId');
	const cachedLabel = localStorage.getItem('sourceTenantLabel');

	if (cachedTenantId && cachedLabel && parseInt(cachedTenantId) === sourceTenantId) {
		const cachedData = JSON.parse(cachedLabel);
		applyBranding(cachedData);
	} else {
		// Tenant ID mismatch or no cache - set the new tenant ID
		localStorage.setItem("sourceTenantId", sourceTenantId);
	}

	// Fetch latest branding data and update
	$.get(`${assetsUrl}/a/${sourceTenantId}/login.json?cache=${new Date().getTime()}`,(data)=>{
		localStorage.setItem("sourceTenantLabel", JSON.stringify(data));
		applyBranding(data);
	});
} else {
	// Cache URL for non-whitelisted URLs as well
	const currentUrl = window.location.href;
    $('title').html('CitusHealth Desktop App');
	// For non-whitelisted URLs, remove branding data as they don't use custom branding
	localStorage.removeItem('sourceTenantId');
	localStorage.removeItem('sourceTenantLabel');
	// Set Okta configuration based on current domain environment
	if (currentUrl.indexOf('app-stage.citushealth.com') !== -1) {
		setOktaConfig('stage');
	} else if (currentUrl.indexOf('app-uat.citushealth.ca') !== -1) {
		setOktaConfig('uat-ca');
	} else if (currentUrl.indexOf('app-uat.citushealth.com') !== -1) {
		setOktaConfig('uat');
	} else if (/app-.*\.citushealth\.com/.test(currentUrl) || /app-.*\.cituswhitelabled\.com/.test(currentUrl)) {
		setOktaConfig('qa');
	} else {
		setOktaConfig('citushealth');
	}
}
// TODO: for temporary checking okta flow, we can remove later
if (window.location.href.includes("auth=okta")) {
    localStorage.setItem("authFlow", "okta");
}



// WEBPACK FOOTER //
// src/assets/lib/tenant-white-labeling.js